import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const cardSettings = {
	trigger: '.home-people',
	duration: 2,
	scrub: true,
	start: 'top bottom',
	end: 'bottom',
};

function init() {
	$('.home-hero').addClass('is-active');

	ScrollTrigger.matchMedia({
		'(min-width: 320px)': () => {
			ScrollTrigger.create({
				trigger: '.home-people',
				start: 'top top',
				end: 'bottom',
				toggleClass: 'is-active',
			});
		},
		'(min-width: 768px)': () => {
			ScrollTrigger.create({
				trigger: '.footer',
				start: 'top top',
				end: 'bottom',
				toggleClass: {
					targets: '.header',
					className: 'is-hide',
				},
			});

			gsap.to('.home-hero__line--item-2', {
				scrollTrigger: {
					trigger: '.home-hero',
					duration: 2,
					scrub: true,
					start: 'top top',
					end: 'bottom',
				},
				top: '300px',
			});

			gsap.to('.home-people__item:nth-child(3n+1)', {
				scrollTrigger: cardSettings,
				y: '-20vh',
			});

			gsap.to('.home-people__item:nth-child(3n+2)', {
				scrollTrigger: cardSettings,
				y: '-10vh',
			});

			gsap.to('.home-people__item:nth-child(3n)', {
				scrollTrigger: cardSettings,
				y: '-30vh',
			});
		},
	});
}

export default {
	init,
};
